import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { uniqBy } from 'lodash';
import classNames from 'classnames';
import Collapse from '@/components/collapse';
import TagList from '@/components/tag-list';
import { RootState } from '@/models/index';
import CitySelectContent from '../city-select-content';
import IndustrySelectContent from '../industry-select-content';
import styles from './index.module.scss';

export default function Filter({
  hotCity,
  industry,
  financeRounds,
  featureLabel,
  // brandRanking,
  lastFinanceYear,
  companyCreateYear,
}) {
  const dispatch = useDispatch();
  const nodeRef = useRef();
  const { filterData } = useSelector<RootState, RootState['brand']>(state => state.brand);
  const { token } = useSelector((state: RootState) => state.user);
  const [startYear, setStartYear] = useState('');
  const [endYear, setEndYear] = useState('');
  const dateContentRef = useRef();
  const disabledDateStart = current => {
    if (!endYear) {
      return current.year() > moment().year();
    } else {
      return current.year() > endYear;
    }
  };
  const disabledDateEnd = current => {
    return current.year() < startYear || current.year() > moment().year();
  };
  const handleChange: any = (value, id, type) => {
    let filterIds = [];
    if (type) {
      filterIds = filterData.filter(item => type !== item.type);
    } else {
      if (id) {
        filterIds = [...filterData.filter(item => id.indexOf(item.id) <= -1), ...value];
      } else {
        filterIds = [...filterData, ...value];
      }
      filterIds = uniqBy([...filterIds, ...value], 'id');
    }
    filterIds = uniqBy(filterIds, 'name');
    dispatch({ type: 'brand/setFilterData', payload: filterIds.filter(item => +item.id > 0) });
  };
  // const handleSingleChange = (value, id, type) => {
  //   let filterIds = [];
  //   if (id) {
  //     filterIds = [...filterData.filter(item => id.indexOf(item.id) <= -1 && type !== item.type), ...value];
  //   } else {
  //     filterIds = [...filterData.filter(item => type !== item.type), ...value];
  //   }
  //   filterIds = uniqBy(filterIds, 'name');
  //   dispatch({ type: 'brand/setFilterData', payload: filterIds.filter(item => +item.id > 0) });
  // };

  useEffect(() => {
    if (!filterData?.find(item => item.id === 111)) {
      setStartYear('');
    }
    if (!filterData?.find(item => item.id === 222)) {
      setEndYear('');
    }
  }, [filterData]);
  return (
    <div className={styles.filter} ref={nodeRef}>
      <Collapse title="所属行业">
        <TagList
          list={industry || []}
          className={styles.normal}
          onChange={handleChange}
          allItem={{ allName: '全部行业', allType: 'industry' }}
          fieldNames={{ label: 'conSearchItemId', value: 'searchItemName', type: 'searchItemType' }}
          onClick={
            token
              ? item => {
                  dispatch({
                    type: 'modal/open',
                    payload: { content: <IndustrySelectContent industry={industry} id={item?.originItemId} /> },
                  });
                }
              : () => dispatch({ type: 'modal/openUserLoginModal', payload: 'login' })
          }
        ></TagList>
      </Collapse>
      <Collapse title="所属地区">
        <TagList
          list={hotCity || []}
          onChange={handleChange}
          fieldNames={{ label: 'conSearchItemId', value: 'searchItemName', type: 'searchItemType' }}
          width={80}
          className={styles.normal}
          allItem={{ allName: '全国', allType: 'hot_city' }}
          otherClick={() => {
            // dispatch({ type: 'brand/setHasOtherCity', payload: true });
            dispatch({ type: 'modal/open', payload: { content: <CitySelectContent hotCity={hotCity} /> } });
          }}
          onClick={token ? undefined : () => dispatch({ type: 'modal/openUserLoginModal', payload: 'login' })}
        ></TagList>
      </Collapse>
      {/*<Collapse title="行业排名">*/}
      {/*  <TagList*/}
      {/*    list={brandRanking || []}*/}
      {/*    onChange={handleSingleChange}*/}
      {/*    className={styles.normal}*/}
      {/*    allItem={{ allName: '全部', allType: 'brand_ranking' }}*/}
      {/*    fieldNames={{ label: 'conSearchItemId', value: 'searchItemName', type: 'searchItemType' }}*/}
      {/*    isSingle={true}*/}
      {/*    onClick={token ? undefined : () => dispatch({ type: 'modal/openUserLoginModal', payload: 'login' })}*/}
      {/*  ></TagList>*/}
      {/*</Collapse>*/}
      <Collapse title="融资轮次">
        <TagList
          list={financeRounds || []}
          onChange={handleChange}
          className={styles.normal}
          allItem={{ allName: '全部', allType: 'finance_rounds' }}
          fieldNames={{ label: 'conSearchItemId', value: 'searchItemName', type: 'searchItemType' }}
          // width={94}
          onClick={token ? undefined : () => dispatch({ type: 'modal/openUserLoginModal', payload: 'login' })}
        ></TagList>
      </Collapse>
      <Collapse title="最新获投">
        <TagList
          list={lastFinanceYear || []}
          onChange={handleChange}
          className={styles.normal}
          allItem={{ allName: '全部', allType: 'last_finance_year' }}
          fieldNames={{ label: 'conSearchItemId', value: 'searchItemName', type: 'searchItemType' }}
          // width={94}
          onClick={token ? undefined : () => dispatch({ type: 'modal/openUserLoginModal', payload: 'login' })}
        ></TagList>
        <div className={classNames('flex-row-nowrap', 'flex-between-center')} ref={dateContentRef}>
          <div>
            <DatePicker
              getPopupContainer={() => dateContentRef.current}
              value={startYear ? moment(startYear, 'yyyy') : null}
              placeholder="开始时间"
              picker="year"
              onChange={date => {
                if (date) {
                  setStartYear(date ? `${moment(date).year()}` : '');
                  handleChange(
                    [
                      {
                        id: 111,
                        name: `${moment(date).year()}年后`,
                        date: moment(date).year(),
                        dateType: 'start',
                        type: 'last_finance_year_min',
                      },
                    ],
                    [111]
                  );
                } else {
                  dispatch({ type: 'brand/setFilterData', payload: filterData.filter(item => item.id !== 111) });
                }
              }}
              disabledDate={disabledDateStart}
            />
          </div>
          <span>~</span>
          <div>
            <DatePicker
              getPopupContainer={() => dateContentRef.current}
              value={endYear ? moment(endYear, 'yyyy') : null}
              placeholder="结束时间"
              picker="year"
              onChange={date => {
                if (date) {
                  setEndYear(date ? `${moment(date).year()}` : '');
                  handleChange(
                    [
                      {
                        id: 222,
                        name: `${moment(date).year()}年前`,
                        date: moment(date).year(),
                        dateType: 'end',
                        type: 'last_finance_year_max',
                      },
                    ],
                    [222]
                  );
                } else {
                  dispatch({ type: 'brand/setFilterData', payload: filterData.filter(item => item.id !== 222) });
                }
              }}
              disabledDate={disabledDateEnd}
            />
          </div>
        </div>
      </Collapse>
      <Collapse title="成立时间">
        <TagList
          list={companyCreateYear || []}
          onChange={handleChange}
          className={styles.normal}
          allItem={{ allName: '全部', allType: 'company_create_year' }}
          fieldNames={{ label: 'conSearchItemId', value: 'searchItemName', type: 'searchItemType' }}
          // width={94}
          onClick={token ? undefined : () => dispatch({ type: 'modal/openUserLoginModal', payload: 'login' })}
        ></TagList>
      </Collapse>
      <Collapse title="特色标签">
        <TagList
          list={featureLabel || []}
          onChange={handleChange}
          className={styles.normal}
          allItem={{ allName: '全部', allType: 'feature_label' }}
          fieldNames={{ label: 'conSearchItemId', value: 'searchItemName', type: 'searchItemType' }}
          onClick={token ? undefined : () => dispatch({ type: 'modal/openUserLoginModal', payload: 'login' })}
        ></TagList>
      </Collapse>
    </div>
  );
}
